import { Box } from '@mui/material';
import { IconButtonAnimate } from 'src/components/animate';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdClose } from 'react-icons/md';

type Props = {
  onToggleCollapse?: VoidFunction;
  isCollapseOpen?: boolean;
};

export default function HamburgerButton({ onToggleCollapse, isCollapseOpen }: Props) {
  return (
    <IconButtonAnimate onClick={onToggleCollapse}>
      <Box
        sx={{
          lineHeight: 0,
          transition: (theme) =>
            theme.transitions.create('transform', {
              duration: theme.transitions.duration.shorter,
            }),
          ...(isCollapseOpen && {
            transform: 'rotate(180deg)',
          }),
        }}
      >
        {isCollapseOpen ? <MdClose size={32} /> : <GiHamburgerMenu size={32} />}
      </Box>
    </IconButtonAnimate>
  );
}
